import React from "react";
import AllUsers from "../User/UserModule/AllUsers";

const Users = () => {
  return (
    <div>
      <AllUsers />
    </div>
  );
};

export default Users;
